import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  ref: "dialogEL",
  class: "w-screen max-w-none min-h-screen bg-white backdrop:backdrop-filter backdrop:bg-opacity-0"
}
const _hoisted_2 = { class: "fixed top-0 inset-x-0 z-1 bg-white flex justify-between items-center w-full h-16 md:h-32 px-4 md:px-20 md:pt-12 border-b-[0.5px] md:border-b-0 border-black-300" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "px-4 md:px-20 pt-25 md:pt-44 pb-9 md:pb-20 grid md:grid-cols-[auto_1fr] gap-6 md:gap-15 lg:gap-30" }
const _hoisted_5 = { class: "md:w-40 lg:w-55" }
const _hoisted_6 = { class: "text-heading-4 md:text-heading-3 lg:text-heading-2" }
const _hoisted_7 = { class: "mt-5" }
const _hoisted_8 = { class: "lg:mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "nav-fade",
    onBeforeEnter: $options.show,
    onAfterEnter: $options.lockScroll,
    onBeforeLeave: $options.unlockScroll,
    onAfterLeave: $options.hide
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("dialog", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "logo"),
          _createElementVNode("button", {
            class: "flex justify-center items-center md:w-20 md:h-20",
            "aria-label": $options.$globalLabels.close,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.globalNavOpened = false))
          }, [
            _createVNode(_component_Icon, {
              name: "close",
              class: "w-6 h-6 stroke-current"
            })
          ], 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString($props.title), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString($props.description), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _renderSlot(_ctx.$slots, "default", {
              isMobileScreen: $data.isMobileScreen,
              openRegion: $data.openRegion,
              toggleRegion: $options.toggleRegion
            })
          ])
        ])
      ], 512), [
        [_vShow, _ctx.globalNavOpened]
      ])
    ]),
    _: 3
  }, 8, ["onBeforeEnter", "onAfterEnter", "onBeforeLeave", "onAfterLeave"]))
}